import { useEffect, useState } from "react";
import { formatDuration } from "../lib/format";

interface ElapsedTimerProps {
  getLiveFocusedMs: () => number;
  solvedAt: number | null;
}

/**
 * Displays active (focused) time. Ticks every second while unsolved
 * to keep the display updating. getLiveFocusedMs includes the current
 * visible segment so the timer counts up smoothly.
 */
export function ElapsedTimer({ getLiveFocusedMs, solvedAt }: ElapsedTimerProps) {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (solvedAt) return;
    const interval = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(interval);
  }, [solvedAt]);

  return <>{formatDuration(getLiveFocusedMs())}</>;
}
